// extracted by mini-css-extract-plugin
module.exports = {"user-form":"UserForm_user-form__1agkV","button":"UserForm_button__VSf2r"};